import { useRef, useState } from "react";
import { setValue } from "../modules/Utils";
import { useI18n } from "Hooks";
import {
  getEndType,
  isRecurringSchoolCalendarEventActionsEnabled,
  getSelectedAcademicYearForSchool,
} from "../../../modules/Utils";
import { getSummaryText } from "MyCalendar/modules/Selector";
import { useReduxState } from "Login/routes/Administrator/commonComponents/SubjectStandardsV2/hooks";

const useUpdateRecurrance = props => {
  const { updateEventModalV2, eventModalV2, isOnlyRemindersUpdated } = props;

  const { t } = useI18n(["common", "calendar"]);
  const academicYearSelected = useReduxState(getSelectedAcademicYearForSchool);
  const { endDate: academicEndDate } = academicYearSelected;
  const repeatEventModalActionRef = useRef({});
  const {
    isCurrentEventIsRepeatEvent,
    isRepeatEvent,
    readOnlyExistingRepeatEventSettings,
    startDate,
    repeatEventSettings,
  } = eventModalV2 || {};
  const setRepeatScope = setValue("repeatScope", updateEventModalV2);

  const { subtext: existingLabelText } = getSummaryText({
    t,
    state: {
      ...readOnlyExistingRepeatEventSettings,
      repeatType: readOnlyExistingRepeatEventSettings?.frequency,
      endType: getEndType({
        repeatEventSettings: readOnlyExistingRepeatEventSettings,
        academicYearEndDate: academicEndDate,
        count: readOnlyExistingRepeatEventSettings?.count,
      }),
      academicYearEndDate: academicEndDate,
    },
    date: startDate,
  });

  const { subtext: updatedLabelText } = getSummaryText({
    t,
    state: {
      ...repeatEventSettings,
      repeatType: repeatEventSettings?.frequency,
      endType: getEndType({
        repeatEventSettings: repeatEventSettings,
        academicYearEndDate: academicEndDate,
        count: repeatEventSettings?.count,
      }),
      academicYearEndDate: academicEndDate,
    },
    date: startDate,
  });

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const showNewConfirmationModal =
    isCurrentEventIsRepeatEvent &&
    isRecurringSchoolCalendarEventActionsEnabled();
  const clickHandler = () => {
    if (showNewConfirmationModal || isOnlyRemindersUpdated) {
      repeatEventModalActionRef.current?.open?.();
      return;
    }
    setIsConfirmationModalOpen(true);
  };

  const onSaveRecurrenceHandler = value => {
    setIsConfirmationModalOpen(true);
    repeatEventModalActionRef.current?.close?.();
    setRepeatScope(value);
  };

  const onCloseConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setRepeatScope("");
  };

  const isRemoveRepeatRecurranceSettings =
    showNewConfirmationModal && !isRepeatEvent;
  return {
    clickHandler,
    isConfirmationModalOpen,
    setIsConfirmationModalOpen,
    onSaveRecurrenceHandler,
    repeatEventModalActionRef,
    existingLabelText,
    updatedLabelText,
    showNewConfirmationModal,
    t,
    isRepeatEvent,
    onCloseConfirmationModal,
    isRemoveRepeatRecurranceSettings,
  };
};

export default useUpdateRecurrance;
